import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import routes from 'src/routes';
import { Provider } from 'react-redux';
import { store } from './_helpers';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import dotenv from 'dotenv';
dotenv.config();
// console.log('detailssss', process.env.REACT_APP_STRIPE);
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE);
const App = () => {
  const routing = useRoutes(routes);

  return (
    <Provider store={store}>
      <Elements stripe={stripePromise}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          {routing}
        </ThemeProvider>
      </Elements>
    </Provider>
  );
};

export default App;
